/**
 * Employee / outsourcer master list (出勤簿 EMP tab).
 * Source: `2026-04 出勤簿 Employee and Outsourcer.xlsx - EMP.csv`
 */

/** @typedef {{
 *   name: string,
 *   nameInKoneko: string,
 *   contractType: string,
 *   status: string,
 *   empOutNo: string,
 *   fullName: string,
 *   empOutId: string,
 *   roleNote: string,
 *   notes: string,
 * }} PayrollEmployeeRosterRow */

/** @type {PayrollEmployeeRosterRow[]} */
export const PAYROLL_EMPLOYEE_ROSTER = [
  {
    name: "Liam",
    nameInKoneko: "Liam Conroy",
    contractType: "業務執行社員 / Representative partner",
    status: "Management",
    empOutNo: "E000001",
    fullName: "Conroy, William David",
    empOutId: "E000001-Liam",
    roleNote: "Director",
    notes: "",
  },
  {
    name: "Marsden",
    nameInKoneko: "Marsden Jacques",
    contractType: "正社員 / Permanent employees",
    status: "EMPLOYEE",
    empOutNo: "E000006",
    fullName: "Jacques, Marsden",
    empOutId: "E000006-Marsden",
    roleNote: "",
    notes: "",
  },
  {
    name: "Owen",
    nameInKoneko: "Owen Bennett",
    contractType: "業務委託 / Overseas Outsourcing",
    status: "UK OUTSOURCE",
    empOutNo: "O000001",
    fullName: "Benett, Owen Charles",
    empOutId: "O000001-Owen",
    roleNote: "",
    notes: "",
  },
  {
    name: "Chris",
    nameInKoneko: "",
    contractType: "正社員 / Permanent employees",
    status: "EMPLOYEE",
    empOutNo: "E000007",
    fullName: "McLaughlin, Christoph",
    empOutId: "E000007-Chris",
    roleNote: "",
    notes: "",
  },
  {
    name: "Florian",
    nameInKoneko: "Florian Thalmann",
    contractType: "正社員 / Permanent employees",
    status: "EMPLOYEE",
    empOutNo: "E000009",
    fullName: "Florian, Thalman",
    empOutId: "E000009-Florian",
    roleNote: "",
    notes: "",
  },
  {
    name: "Sacha",
    nameInKoneko: "Sacha Waked",
    contractType: "正社員 / Permanent employees",
    status: "EMPLOYEE",
    empOutNo: "E000012",
    fullName: "Waked, Sacha",
    empOutId: "E000012-Sacha",
    roleNote: "",
    notes: "",
  },
  {
    name: "Sebastian",
    nameInKoneko: "Sebastian",
    contractType: "正社員 / Permanent employees",
    status: "EMPLOYEE",
    empOutNo: "E000016",
    fullName: "Kocjancic,Sebastian",
    empOutId: "E000016-Sebastian",
    roleNote: "",
    notes: "",
  },
  {
    name: "Reegesh",
    nameInKoneko: "Regesh Maharjan",
    contractType: "代表社員 / Managing Director",
    status: "EMPLOYEE",
    empOutNo: "E000004",
    fullName: "Maharajan, Regesh",
    empOutId: "E000004-Reegesh",
    roleNote: "",
    notes: "",
  },
  {
    name: "Marisa",
    nameInKoneko: "Marisa",
    contractType: "有期パートタイマー / Contract Part-time Employee",
    status: "Management",
    empOutNo: "E000011",
    fullName: "永見　真里佐",
    empOutId: "E000011-Marisa",
    roleNote: "Director",
    notes: "",
  },
  {
    name: "Aroni",
    nameInKoneko: "",
    contractType: "パートタイマー / Part-time Employee",
    status: "EMPLOYEE",
    empOutNo: "E000014",
    fullName: "Hipperson, Aaron Shane",
    empOutId: "E000014-Aroni",
    roleNote: "",
    notes: "",
  },
  {
    name: "Tsuru",
    nameInKoneko: "Akinori Tsurutani",
    contractType: "業務委託 / Overseas Outsourcing",
    status: "EMPLOYEE",
    empOutNo: "E000003",
    fullName: "鶴谷　晃徳",
    empOutId: "E000003-Tsuru",
    roleNote: "",
    notes: "",
  },
  {
    name: "Rishek",
    nameInKoneko: "Rishek Pandey",
    contractType: "正社員 / Permanent employees",
    status: "OUTSOURCE",
    empOutNo: "O000002",
    fullName: "Pandey, Rishek",
    empOutId: "O000002-Rishek",
    roleNote: "",
    notes: "",
  },
  {
    name: "Pablo",
    nameInKoneko: "Pablo Antoniadis",
    contractType: "契約社員 / Contract employees",
    status: "EMPLOYEE",
    empOutNo: "E000010",
    fullName: "Antoniadis Pablo",
    empOutId: "E000010-Pablo",
    roleNote: "",
    notes: "",
  },
  {
    name: "Kai",
    nameInKoneko: "Kai Nyame Abbey",
    contractType: "業務委託 / Overseas Outsourcing",
    status: "EMPLOYEE",
    empOutNo: "E000015",
    fullName: "Abbey Kai Nyame",
    empOutId: "E000015-Kai",
    roleNote: "",
    notes: "",
  },
  {
    name: "Victor",
    nameInKoneko: "Victor Frade",
    contractType: "業務委託 / Overseas Outsourcing",
    status: "OUTSOURCE",
    empOutNo: "O000003",
    fullName: "Frade, Victor",
    empOutId: "O000003-Victor",
    roleNote: "",
    notes: "",
  },
  {
    name: "Santosh",
    nameInKoneko: "Santosh Pokharel",
    contractType: "業務委託 / Outsourcing",
    status: "OUTSOURCE",
    empOutNo: "O000004",
    fullName: "Pokharel, Santosh",
    empOutId: "O000004-Santosh",
    roleNote: "",
    notes: "",
  },
  {
    name: "Chihiro",
    nameInKoneko: "Nao Chihiro",
    contractType: "業務委託 / Overseas Outsourcing",
    status: "OUTSOURCE",
    empOutNo: "O000005",
    fullName: "奈尾　知弥",
    empOutId: "O000005-Chihiro",
    roleNote: "",
    notes: "",
  },
  {
    name: "Abdelrahman (Adam)",
    nameInKoneko: "Adam Eba",
    contractType: "業務委託 / Outsourcing",
    status: "OUTSOURCE",
    empOutNo: "O000006",
    fullName: "Eba, Abdelrahmen",
    empOutId: "O000006-Abdelrahman (Adam)",
    roleNote: "",
    notes: "",
  },
  {
    name: "Sol",
    nameInKoneko: "",
    contractType: "業務委託 / Overseas Outsourcing",
    status: "OUTSOURCE",
    empOutNo: "O000007",
    fullName: "Waringues Ep Waled Solene Laura Natacha",
    empOutId: "O000007-Sol",
    roleNote: "",
    notes: "",
  },
  {
    name: "Yohann",
    nameInKoneko: "",
    contractType: "契約社員 / Contract employees",
    status: "OUTSOURCE",
    empOutNo: "O000008",
    fullName: "Erhard, Yohann",
    empOutId: "O000008-Yohann",
    roleNote: "",
    notes: "",
  },
  {
    name: "Douglas",
    nameInKoneko: "Douglas Driving",
    contractType: "契約社員 / Contract employees",
    status: "EMPLOYEE",
    empOutNo: "E000023",
    fullName: "Driving karl Douglas",
    empOutId: "E000023-Douglas",
    roleNote: "",
    notes: "Employee starting 9/19",
  },
  {
    name: "Kiho",
    nameInKoneko: "Kiho",
    contractType: "業務委託 / Overseas Outsourcing",
    status: "EMPLOYEE",
    empOutNo: "E000018",
    fullName: "森田　季帆",
    empOutId: "E000018-Kiho",
    roleNote: "",
    notes: "",
  },
  {
    name: "Kamran",
    nameInKoneko: "Kamran Manzoor",
    contractType: "業務委託 / Outsourcing",
    status: "OUTSOURCE",
    empOutNo: "O000009",
    fullName: "Manzoor, Kamran",
    empOutId: "O000009-Kamran",
    roleNote: "",
    notes: "",
  },
  {
    name: "Jake",
    nameInKoneko: "Jake Campbell",
    contractType: "業務委託 / Outsourcing",
    status: "OUTSOURCE",
    empOutNo: "O000010",
    fullName: "Campbell, Jake",
    empOutId: "O000010-Jake",
    roleNote: "",
    notes: "",
  },
  {
    name: "Ben",
    nameInKoneko: "Ben Ridge",
    contractType: "業務委託 / Overseas Outsourcing",
    status: "EMPLOYEE",
    empOutNo: "E000022",
    fullName: "Ridge, Benjamin David",
    empOutId: "E000022-Ben",
    roleNote: "",
    notes: "",
  },
  {
    name: "Tim",
    nameInKoneko: "Tim Lobes",
    contractType: "契約社員 / Contract employees",
    status: "OUTSOURCE",
    empOutNo: "O000011",
    fullName: "Lobes, Timothy",
    empOutId: "O000011-Tim",
    roleNote: "",
    notes: "",
  },
  {
    name: "Sylvio",
    nameInKoneko: "Sylvio Mafort",
    contractType: "業務委託 / Overseas Outsourcing",
    status: "EMPLOYEE",
    empOutNo: "E000019",
    fullName: "Mafort Sylvio",
    empOutId: "E000019-Sylvio",
    roleNote: "",
    notes: "",
  },
  {
    name: "Moazz",
    nameInKoneko: "Moaaz Sirri",
    contractType: "有期パートタイマー / Contract Part-time Employee",
    status: "OUTSOURCE",
    empOutNo: "O000012",
    fullName: "Sirri, Moaaz",
    empOutId: "O000012-Moazz",
    roleNote: "",
    notes: "",
  },
  {
    name: "Tokiko",
    nameInKoneko: "Tokiko Shima",
    contractType: "業務委託 / Overseas Outsourcing",
    status: "EMPLOYEE",
    empOutNo: "E000020",
    fullName: "Shima Tokiko",
    empOutId: "E000020-Tokiko",
    roleNote: "",
    notes: "",
  },
  {
    name: "Dang",
    nameInKoneko: "Dang Tru Cao",
    contractType: "業務委託 / Overseas Outsourcing",
    status: "OUTSOURCE",
    empOutNo: "O000013",
    fullName: "Cao, Dang Tru",
    empOutId: "O000013-Dang",
    roleNote: "",
    notes: "",
  },
  {
    name: "Shrawan",
    nameInKoneko: "Shrawan Kumar Thakur",
    contractType: "業務委託 / Overseas Outsourcing",
    status: "OUTSOURCE",
    empOutNo: "O000014",
    fullName: "Thajur, Shrawan Kumar",
    empOutId: "O000014-Shrawan",
    roleNote: "",
    notes: "",
  },
  {
    name: "Luke",
    nameInKoneko: "Luke",
    contractType: "契約社員 / Contract employees",
    status: "EMPLOYEE",
    empOutNo: "E000024",
    fullName: "Stephenson, Luke",
    empOutId: "E000024-Luke",
    roleNote: "",
    notes: "From 2026-02-01",
  },
  {
    name: "Martin",
    nameInKoneko: "Martin Ogg",
    contractType: "",
    status: "EMPLOYEE",
    empOutNo: "E000026",
    fullName: "Ogg, Martin",
    empOutId: "E000026-Martin",
    roleNote: "",
    notes: "Employee from 2026",
  },
  {
    name: "Nadir",
    nameInKoneko: "Nadir White",
    contractType: "",
    status: "EMPLOYEE",
    empOutNo: "E000025",
    fullName: "Whatlaw, Nadir Adam",
    empOutId: "E000025-Nadir",
    roleNote: "",
    notes: "",
  },
  {
    name: "Esteban",
    nameInKoneko: "",
    contractType: "",
    status: "Yodobashi",
    empOutNo: "",
    fullName: "",
    empOutId: "Yodobashi-Esteban",
    roleNote: "",
    notes: "",
  },
  {
    name: "Anson",
    nameInKoneko: "Anson Lau",
    contractType: "",
    status: "INTERN",
    empOutNo: "INTERN",
    fullName: "Lau, Anson",
    empOutId: "INTERN-Anson",
    roleNote: "",
    notes: "",
  },
];

/** Extra roster short-name → planning username keys not in konekoATargets. */
export const PAYROLL_ROSTER_NAME_ALIASES = {
  liam: "liam_maneki",
  marsden: "jacques",
  reegesh: "reegesh",
  nadir: "nad",
  owen: "owen",
  aroni: "aroni",
  sol: "sol",
  yohann: "yohann",
  "abdelrahman (adam)": "abdel",
  abdelrahman: "abdel",
  adam: "abdel",
  tsuru: "tsuru",
};

/**
 * Omit from payroll from this calendar month onward when nekoapi Member data is missing
 * or still marks the person as working. Keys: roster `name` or planning username.
 */
export const PAYROLL_EXCLUDED_FROM_MONTH = {
  Owen: "2026-06",
  Aroni: "2025-09",
  Sol: "2023-01",
  Yohann: "2023-01",
  "Abdelrahman (Adam)": "2026-06",
  owen: "2026-06",
  abdel: "2026-06",
  aroni: "2025-09",
  sol: "2023-01",
  yohann: "2023-01",
};
